<template>
  <div>
    <div class="c-grid">
      <div class="c-grid__items">
        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
          <Select v-model="comparisonType" :options="keywordComparisonAnalysisTypeOptions" />
          <section>
            <div>
              <div class="p-table">
                <div v-if="comparisonKeywords.length !== 0" class="p-table__content">
                  <template v-if="currentSelect === 'brandComparison'">
                    <ComparisonBrandList
                      :items="comparisonKeywords"
                      :type="currentTab"
                    />
                  </template>
                  <template v-else>
                    <ComparisonStoreList
                      :items="comparisonKeywords"
                      :type="currentTab"
                    />
                  </template>
                </div>
                <template v-else>
                  {{ $t('messages.noData') }}
                </template>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import localeStringMixin from '../../../../mixins/localeStringMixin'
import ComparisonStoreList from './StoreList'
import ComparisonBrandList from './BrandList'
import Select from '../../../../components/Select'
import {keywordComparisonAnalysisTypes} from '../../../../modules/analysis'

export default {
  name: 'CompaniesAnalysisKeywordsList',
  components: {
    ComparisonStoreList,
    ComparisonBrandList,
    Select
  },
  mixins: [localeStringMixin],
  props: {
    comparisonKeywords: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      comparisonType: this.$route.query.select || 'storeComparison'
    }
  },
  computed: {
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentSelect() {
      return this.$route.query.select
    },
    keywordComparisonAnalysisTypeOptions() {
      const obj = {}
      keywordComparisonAnalysisTypes.forEach(v => obj[v.name] = v.id)
      return obj
    },
    companyUuid: function () {
      return this.$route.params.company_uuid
    },
    currentTab() {
      return this.$route.query.tab
    }
  },
  watch: {
    comparisonType(val) {
      this.$router.push({ query: { tab: this.currentTab, select: val } })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.p-table__content {
  &::-webkit-scrollbar {
    display: initial;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #D2D5DB;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
}
.c-select {
  width: 20%;
}
</style>
